const MultipartUploadConfig = {
  CHUNK_SIZE: 1024 * 1024 * 200, // 200mb
  MAX_THREADS_QUANTITY: 5,
};

export default MultipartUploadConfig;
